/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'arrow-left': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M722.035 49.216l-6.186 5.302-461.017 400.628c-15.613 13.55-25.334 33.877-25.334 56.56 0 22.682 10.016 43.008 25.334 56.559l460.133 400.333 7.66 6.775c7.364 5.008 16.201 7.954 25.628 7.954 25.628 0 46.543-21.799 46.543-48.9V89.573c0-27.101-20.915-48.9-46.543-48.9-9.721 0-18.853 3.24-26.218 8.543z"/>'
  }
})
